"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var buttonsGroup_1 = require("../buttonsGroup");
var icon_1 = require("../icon");
var common_1 = require("../../common");
var DensitySwitch = /** @class */ (function (_super) {
    tslib_1.__extends(DensitySwitch, _super);
    function DensitySwitch(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChange = function (value) {
            var onChange = _this.props.onChange;
            onChange(common_1.Density[value]);
        };
        return _this;
    }
    DensitySwitch.prototype.render = function () {
        var _a = this.props, className = _a.className, onChange = _a.onChange, density = _a.density, small = _a.small, others = tslib_1.__rest(_a, ["className", "onChange", "density", "small"]);
        var iconSize = small ? 2.24 : 2.8;
        var sharedGroupButtonProps = {
            icon: true,
            small: small
        };
        return (React.createElement(buttonsGroup_1.ButtonsGroup, tslib_1.__assign({}, others, { className: className, onChange: this.onChange, active: common_1.Density[density], icons: true }),
            React.createElement(buttonsGroup_1.GroupButton, tslib_1.__assign({ name: common_1.Density[common_1.Density.Large] }, sharedGroupButtonProps),
                React.createElement(icon_1.default, { size: iconSize, iconName: "icon-density-1" })),
            React.createElement(buttonsGroup_1.GroupButton, tslib_1.__assign({ name: common_1.Density[common_1.Density.Medium] }, sharedGroupButtonProps),
                React.createElement(icon_1.default, { size: iconSize, iconName: "icon-density-2" })),
            React.createElement(buttonsGroup_1.GroupButton, tslib_1.__assign({ name: common_1.Density[common_1.Density.Small] }, sharedGroupButtonProps),
                React.createElement(icon_1.default, { size: iconSize, iconName: "icon-density-3" }))));
    };
    DensitySwitch.defaultProps = {};
    return DensitySwitch;
}(React.Component));
exports.default = DensitySwitch;
